import React, { Component } from 'react';
import { withStyles, withWidth } from '@material-ui/core';
import { connect } from 'react-redux';
import withTranslations from '../../../translations';

import { singleJobPath } from '../../../constants/urls';

import JobMobileView from './views/JobMobile';
import JobDesktopView from './views/JobDesktop';
import TagJob from './TagJob/TagJob';
import JobProgress from './JobProgress/JobProgress';
import EditLink from './EditLink/EditLink';

import {
  Grid,
  Typography,
} from '../../base';

import { removeLeadingZeros } from '../../../utils/utils';

import {
  hasAlert,
  getJobProgress,
  getLastUpdatedStatus,
} from '../../../constants/job';

import {
  getJobTableColumns,
  smallScreens,
} from './constants';

const styles = theme => ({
  tableHeaderRow: {
    height: 36,
    borderRadius: theme.shape.borderRadius,

    [theme.breakpoints.up('sm')]: {
      background: theme.palette.background.paper,
    },
  },
  tableHeaderRowAlert: {
    height: 36,
    background: theme.palette.error.light,
  },
  tableHeaderText: {
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  tableHeaderTextColor: {
    color: theme.palette.text.primary,
    maxWidth: '500px',
    overflow: 'auto',
  },
  tableHeaderTextColorAlert: {
    color: 'white',
    maxWidth: '500px',
    overflow: 'auto',
  },
  editCell: {
    '& > *': {
      float: 'right',
    },
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});

class Job extends Component {
  state = {
    expanded: false,
    checked: !!this.props.data.tagged,
  }

  getLastStatus = (status, c, t, gt) => {
    const workflow = t.workFlow;
    const analysis = t.analysisFlow;
    const calculatedStatuses = getLastUpdatedStatus(status);

    return (
      <div className={c.statusContainer}>
        <Grid item>
          <Typography><i>{workflow}:</i> {gt[calculatedStatuses[0]]}</Typography>
          <Typography><i>{analysis}:</i> {gt[calculatedStatuses[1]]}</Typography>
        </Grid>
      </div>
    );
  }

  getAdditionalInfo = (dataObject, c, t, gt) => {
    const { notificationNumber, serviceOrderNumber } = dataObject;

    return (
      <div className={c.statusContainer}>
          <Grid item>
            <Typography><i>{t.notificationNumber}:</i> {notificationNumber ? removeLeadingZeros(notificationNumber) : gt.noInfo}</Typography>
            <Typography><i>{t.serviceOrderNumber}:</i> {serviceOrderNumber ? removeLeadingZeros(serviceOrderNumber) : gt.noInfo}</Typography>
          </Grid>
      </div>
    );
  }

  handleChecked = e => {
    const jobId = e.target.value;

    this.setState(prevState =>
      ({ checked: !prevState.checked }),
      () => this.props.handleTagJob(jobId, { tagged: this.state.checked })
    );
  }

  withJobInfo = Component => {
    const { classes: c, t, gt, width, data, user } = this.props;
    const { alerts, progress, id, status, notificationNumber, serviceOrderNumber } = data;
    const { checked } = this.state;
    const isSmallScreen = smallScreens.includes(width);
    const tableColumns = getJobTableColumns(t, user);
    const columns = isSmallScreen ? tableColumns.slice(1, tableColumns.length - 1) : tableColumns;
    const hasAlerts = hasAlert(alerts);
    const steps = getJobProgress(progress, t);
    const tagIconColor = hasAlerts && isSmallScreen ? 'primary' : 'secondary';

    return (
      <Component
        t={t}
        gt={gt}
        data={data}
        columns={columns}
        TagJob={<TagJob value={String(id)} handleClick={this.handleChecked} isChecked={checked} iconColor={tagIconColor} />}
        JobProgress={<JobProgress steps={steps} gt={gt} />}
        EditLink={<EditLink t={t} hasAlerts={hasAlerts} isSmallScreen={isSmallScreen} path={singleJobPath(id)} />}
        lastStatus={this.getLastStatus(status, c, t, gt.Status)}
        additionalInfo={this.getAdditionalInfo({notificationNumber, serviceOrderNumber}, c, t, gt)}
        styles={{
          headerRowStyles: hasAlerts && isSmallScreen ? c.tableHeaderRowAlert : c.tableHeaderRow,
          textColor: hasAlerts && isSmallScreen ? c.tableHeaderTextColorAlert : c.tableHeaderTextColor,
          tableHeaderText: c.tableHeaderText,
          editCell: c.editCell,
        }}
        user={user}
      />
    )
  }

  render() {
    const { width } = this.props;
    const Component = smallScreens.includes(width) ? JobMobileView : JobDesktopView;

    return this.withJobInfo(Component)
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

export default withWidth()(withStyles(styles)(connect(mapStateToProps)(withTranslations(Job, 'Jobs'))));



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/Job.js